import React from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const servicesData = [
  {
    key: "development",
    imgSrc: "image/S1.jpg",
    color: "rgba(15, 139, 227, 0.67)",
  },
  {
    key: "management",
    imgSrc: "image/S2.jpg",
    color: "rgba(70, 85, 105, 0.8)",
  },
  {
    key: "construction",
    imgSrc: "image/S3.jpg",
    color: "rgba(120, 85, 60, 0.8)",
  },
];

const Services = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const direction = i18n.language === "ar" ? "rtl" : "ltr";
  const textAlign = direction === "rtl" ? "right" : "left";
const isRTL = i18n.language === 'ar';

  const fontFamily = isRTL ? "'Tajawal', sans-serif" : 'inherit';
  return (
    <Box
      sx={{
      
        py: 4,
        px: { xs: 2, sm: 4, md: 8 },
        direction,
      }}
    >
      <Typography
      fontFamily={fontFamily}
        variant="h3"
        align="center"
        sx={{
          fontWeight: 700,
          color: "#003d80",
          mb: 6,
          textShadow: "0 2px 6px rgba(0, 0, 0, 0.73)",
        }}
      >
        {t("services.title")}
      </Typography>

      <Grid container spacing={4}>
        {servicesData.map(({ key, imgSrc, color }, idx) => (
          <Grid key={idx} item xs={12} sm={6} md={4}>
            <Box
              sx={{
                position: "relative",
                height: 440,
                borderRadius: 3,
                overflow: "hidden",
                backgroundImage: `url(${imgSrc})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                display: "flex",
                alignItems: "flex-end",
                transition: "transform 0.4s ease",
                boxShadow: `0 8px 24px rgba(0,0,0,0.4)`,
                "&:hover": {
                  transform: "scale(1.03)",
                },
                "&::before": {
                  content: '""',
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: `linear-gradient(to bottom, rgba(0,0,0,0.4), ${color})`,
                  zIndex: 1,
                },
              }}
            >
              <Box
                sx={{
                  position: "relative",
                  zIndex: 2,
                  color: "#fff",
                  width: "100%",
                  p: 3,
                }}
              >
                <Typography
                  fontFamily={fontFamily}
                  variant="h5"
                  sx={{
                    fontWeight: "bold",
                    mb: 1,
                    textAlign,
                  }}
                >
                  {t(`services.${key}.title`)}
                </Typography>
                <Typography
                  fontFamily={fontFamily}
                  variant="body2"
                  sx={{
                    mb: 2,
                    textAlign,
                    lineHeight: 1.6,
                    opacity: 0.9,
                  }}
                >
                  {t(`services.${key}.description`)}
                </Typography>
                <Button
                  variant="outlined"
                  size="small"
                  sx={{
                      fontFamily,
                    color: "#fff",
                    borderColor: "#fff",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#ffffff22",
                      borderColor: "#fff",
                    },
                  }}
                  onClick={() => navigate("/service")}
                >
                  {t("services.learnMore")}
                </Button>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Services;
